import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './types.ts';

// Use these instead of plain `useDispatch` and `useSelector` for type safety
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
